import { audioMessage as message } from '../../Components/Common/Notifications/audioMessage';
import { TrainingAPI } from "../../api/TrainingAPI";
import { SIDE_ID } from "../../Components/Compare/Comparison1V1.jsx";
import {mapDataForHighchartsGroupedBar} from "../../mappers/model/GroupedBarChartMapper"
import { DataColorUtil } from "../../Utils/color_utils";
const trainingAPI = new TrainingAPI();

export const COMPARE_SET_CHARTS = "[COMPARE]_SET_CHARTS";
export const COMPARE_SET_LOADING = "[COMPARE]_SET_LOADING";
export const COMPARE_SET_FILTER = "[COMPARE]_SET_FILTER";
export const COMPARE_SET_1V1_FILTER = "[COMPARE]_SET_1V1_FILTER";
export const COMPARE_MULTI_RANGE_SET_FILTER = "[COMPARE]_MULTI_RANGE_SET_FILTER";
export const COMPARE_SET_MULTI_DATA = "[COMPARE]_SET_MULTI_DATA";
export const COMPARE_SET_MULTI_DATA_ERROR = "[COMPARE]_SET_MULTI_DATA_ERROR";
export const COMPARE_SET_GAME_NUMBER = "[COMPARE]_SET_GAME_NUMBER";
export const COMPARE_SET_GAME_COMPARE = "[COMPARE]_SET_GAME_COMPARE";
export const COMPARE_SET_DATA = "[COMPARE]_SET_DATA";
export const COMPARE_SET_1V1_DATA = "[COMPARE]_SET_1V1_DATA";
export const COMPARE_SET_1V1_DATA_ERROR = "[COMPARE]_SET_1V1_DATA_ERROR";
export const COMPARE_SET_COMPARISON_TYPES = "[COMPARE]_SET_COMPARISON_TYPES";

export const setComparisonCharts = (charts) => ({
  type: COMPARE_SET_CHARTS,
  payload: charts
})

// 'Day Compare' actions
export const setCompareLoading = (loading) => ({
  type: COMPARE_SET_LOADING,
  payload: loading,
});

export const setCompareFilterPlayerGroup = (playerGroup) => ({
  type: COMPARE_SET_FILTER,
  payload: { playerGroup },
});

export const setCompareFilterDates = (index, date) => {
  return async (dispatch, getState) => {
    const {
      filter: { dates },
    } = getState().compare;
    dates[index] = date;
    dispatch({ type: COMPARE_SET_FILTER, payload: { dates } });
  };
};

export const setCompareFilterPosition = (position) => ({
  type: COMPARE_SET_FILTER,
  payload: { position },
});

export const setCompareData = (data) => ({
  type: COMPARE_SET_DATA,
  payload: data,
});

export const setCompareGameNumber = (gameNumber) => ({
  type: COMPARE_SET_GAME_NUMBER,
  payload: gameNumber,
});

export const setCompareGameCompare = (gameCompare) => ({
  type: COMPARE_SET_GAME_COMPARE,
  payload: gameCompare,
});
export const getComparisonData = () => async (dispatch, getState) => {
  dispatch(setCompareLoading(true));
  
  try {
    const state = getState();
    const { compare, team } = state;
    const {
      filter: { dates, position, playerGroup },
      gameCompare,
      gameNumber,
    } = compare;

    const data = await trainingAPI.compareSessions(
      gameCompare,
      gameNumber,
      ...dates,
      position,
      playerGroup
    );

    dispatch(setCompareData(data));

    if (data?.metrics) {
      const metricDict = Object.fromEntries(
        data.metrics.map(metric => [
          metric.key,
          Array.from({ length: data.num_games }, (_, i) => `${i}_${metric.key}__avg`)
        ])
      );

      let dataColorUtil = null;
      if (data?.colors && data?.metrics?.length && team?.color_strategies?.length) {
        dataColorUtil = new DataColorUtil({
          teamName: team?.info?.display_name,
          gpsBaselines: data.colors,
          teamGpsMetrics: data.metrics,
          colorStrategies: team.color_strategies
        });
      }
      
      const charts = data.metrics?.map((metric, index) => ({
        name: metric.name ?? '',
        key: metric.key ?? '',
        data: mapDataForHighchartsGroupedBar({
          dataIn: data,
          games: team?.games,
          metrics: metricDict[metric.key] ?? [],
          teamColors: team?.info?.team_colors,
          isComparison: true,
          dataColorUtil
        })
      }));

      if (charts.length > 0) {
        dispatch(setComparisonCharts(charts));
      }
    }
  } catch (error) {
    console.error('Error fetching comparison data:', error);
  } finally {
    dispatch(setCompareLoading(false));
  }
};

export const emailComparisonData = () => {
  return async (dispatch, getState) => {
    try {
      const {
        filter: { dates },
        gameCompare,
        gameNumber,
      } = getState().compare;
      await trainingAPI.emailComparisonData(
        gameCompare,
        gameNumber,
        dates[0],
        dates[1],
        dates[2],
        dates[3],
        dates[4]
      );
      message.success("Email sent!");
    } catch (e) {
      message.error("Error sending email.");
    }
  };
};

// 1V1 actions
export const set1v1CompareFilterDateRange = (startDate, endDate) => {
  return async (dispatch, getState) => {
    dispatch({ type: COMPARE_SET_1V1_FILTER, payload: { startDate, endDate } });
  };
};

export const set1v1CompareFilterEndDate = (endDate) => {
  return async (dispatch, getState) => {
    dispatch({ type: COMPARE_SET_1V1_FILTER, payload: { endDate } });
  };
};

export const set1v1CompareFilterMetrics = (selectedMetrics) => {
  return async (dispatch, getState) => {
    dispatch({ type: COMPARE_SET_1V1_FILTER, payload: { selectedMetrics } });
  };
};

export const set1v1CompareFilterPlayerSelection = (selections, side_id) => {
  const selectionKey = side_id === SIDE_ID.LEFT ? 'selectionLeft' : 'selectionRight'
  return {
    type: COMPARE_SET_1V1_FILTER,
    payload: { [selectionKey]: selections },
  };
}

export const set1v1CompareData = (data) => ({
  type: COMPARE_SET_1V1_DATA,
  payload: data,
});

export const set1v1CompareDataError = (error) => ({
  type: COMPARE_SET_1V1_DATA_ERROR,
  payload: error,
});

export const get1v1ComparisonData = () => {
  return async (dispatch, getState) => {
    try {
      const {
        filter_1v1: { startDate, endDate, selectionLeft, selectionRight, selectedMetrics }
      } = getState().compare;
      const payload = {
        start_date: startDate?.format("YYYY-MM-DD"),
        end_date: endDate?.format("YYYY-MM-DD"),
        selection_left: selectionLeft,
        selection_right: selectionRight,
        metric_ids: selectedMetrics
      }
      // // TODO: for testing
      // const payload = {
      //   "start_date": "2024-06-01",
      //   "end_date": "2024-06-30",
      //   "selection_left": ["player-3778", "pos-8/10", "group-3"],
      //   "selection_right": ["player-1116", "pos-7/11"],
      //   // "metric_ids": ["gps-2", "gps-1", "testing-1", "forceplate-1586", "wellness-4"]//FAU
      //   "metric_ids": ["gps-2", "gps-3", "testing-58", "forceplate-1684", "wellness-46"]//NCCourage
      // }

      const data = await trainingAPI.get1v1ComparisonData(payload);
      dispatch(set1v1CompareData(data));
    } catch (e) {
      dispatch(set1v1CompareDataError("Error occurred while fetching the data"));
    }
  };
};


// Compare Multiple Date Ranges actions
export const setMultiRangeCompareFilterDateRange = (index, startDate, endDate) => {
  if (index !== null)
    return async (dispatch, getState) => {
      let payload = { dateRangeMap: {} };
      if (startDate === null && endDate === null)
        payload["dateRangeMap"][`${index}`] = null
      else payload["dateRangeMap"][`${index}`] = [startDate, endDate]
      dispatch({ type: COMPARE_MULTI_RANGE_SET_FILTER, payload });
    };
};

export const getMultiRangeComparisonData = () => {
  return async (dispatch, getState) => {
    try {
      const {
        filter_multi_range: { dateRangeMap, playerCardSelections, selectedMetrics }
      } = getState().compare;


      const date_ranges = Object.values(dateRangeMap)
        .filter( (range) => range !== null && range?.length === 2)
        .map( (range) => [range?.[0]?.format("YYYY-MM-DD"), range?.[1]?.format("YYYY-MM-DD")])

      const payload = {
        date_ranges,
        player_selection: playerCardSelections,
        metric_ids: selectedMetrics
      }

      const data = await trainingAPI.getMultiRangeComparisonData(payload);
      dispatch(setMultiRangeCompareData(data));
    } catch (e) {
      dispatch(setMultiRangeCompareDataError("Error occurred while fetching the data"));
    }
  };
};

export const setMultiRangeCompareData = (data) => ({
  type: COMPARE_SET_MULTI_DATA,
  payload: data,
});

export const setMultiRangeCompareDataError = (error) => ({
  type: COMPARE_SET_MULTI_DATA_ERROR,
  payload: error,
});

export const setMultiRangeCompareFilterMetrics = (selectedMetrics) => {
  return async (dispatch, getState) => {
    dispatch({ type: COMPARE_MULTI_RANGE_SET_FILTER, payload: { selectedMetrics } });
  };
};

export const setMultiRangeCompareFilterPlayerSelection = (playerCardSelections) => {
  return {
    type: COMPARE_MULTI_RANGE_SET_FILTER,
    payload: { playerCardSelections },
  };
}